@reference "../styles/ui.css";

/**********************************************************************************************************************
 * Overlay
 **********************************************************************************************************************/
.loading-overlay {
  @apply bg-black/25 absolute inset-0 z-[var(--enterprise-ui-loader-overlay-zindex)];
}

.loading-overlay.full-screen {
  @apply h-[100vh] w-[100vw] fixed top-0 left-0;
}

/**********************************************************************************************************************
 * Loaders shared
 **********************************************************************************************************************/

.loading-overlay :global([class^="loader-"]) {
  @apply box-border flex items-center justify-center m-0 absolute inset-0 z-[var(--enterprise-ui-loader-zindex)];
}

/**********************************************************************************************************************
 * Dual Ring Loader
 **********************************************************************************************************************/

.loading-overlay :global(.loader-dual-ring) {
  --multiplier: 1;
  --size: calc(var(--enterprise-ui-loader-size) * var(--multiplier));
  --border: calc((var(--size) / 18.75) * var(--multiplier));

  @apply inset-0 after:content-[''] after:block after:h-[var(--size)] after:w-[var(--size)] after:rounded-full after:border-solid after:border-transparent after:border-b-hsp-500 after:border-t-hsp-500 after:border-[calc(var(--border))] after:animate-dual-ring;
}

/**********************************************************************************************************************
 * Glow Loader
 **********************************************************************************************************************/
.loading-overlay :global(.loader-glow) {
  --multiplier: 1;
  --size: calc(var(--enterprise-ui-loader-size) * var(--multiplier));
  --border: calc(var(--size) / 37.5);
  --circle: calc(var(--size) / 9.375);

  box-shadow: 0 0 20px rgb(0 0 0 / 0.5);
  text-shadow: 0 0 10px rgb(0 0 0 / 0.5);

  @apply h-[var(--size)] w-[var(--size)] left-[50%] top-[50%] -translate-x-1/2 -translate-y-1/2 border-gray-600 border-solid border-[calc(var(--border))] rounded-full text-hsp-500 text-[calc(var(--size)/9.375)] tracking-[var(--border)] uppercase before:absolute before:block before:content-[''] before:rounded-full before:border-solid before:border-transparent before:border-r-hsp-500 before:border-t-hsp-500 before:border-[calc(var(--border))] before:top-[calc(-1*var(--border))] before:right-[calc(-1*var(--border))] before:bottom-[calc(-1*var(--border))] before:left-[calc(-1*var(--border))] before:animate-glow-border;
}

.loading-overlay :global(.loader-glow div:not(.circle)) {
  @apply flex grow items-center justify-center w-full;
}

.loading-overlay :global(.loader-glow div.circle) {
  box-shadow: 0 0 20px rgb(0 0 0 / 0.5);
  transform: rotate(45deg) translate(calc(var(--size) / 2 - var(--border) / 2)) rotate(-45deg);

  @apply block bg-hsp-500 h-[var(--circle)] w-[var(--circle)] ml-[calc(-1*(var(--circle)/2))] mt-[calc(-1*(var(--circle)/2))] rounded-full absolute left-[50%] top-[50%] animate-glow-circle;
}

/**********************************************************************************************************************
 * Grid Loader
 **********************************************************************************************************************/
.loading-overlay :global(.loader-grid) {
  --multiplier: 1;
  --ball-size: calc(var(--enterprise-ui-loader-size) / 4.6875 * var(--multiplier));
  --margin: calc(var(--enterprise-ui-loader-size) / 18.75 * var(--multiplier));

  @apply grid grid-cols-3 grid-rows-3 left-[50%] top-[50%] h-[calc(3*((2*var(--margin))+var(--ball-size)))] w-[calc(3*((2*var(--margin))+var(--ball-size)))] -translate-x-1/2 -translate-y-1/2;
}

.loading-overlay :global(.loader-grid div) {
  @apply h-[var(--ball-size)] w-[var(--ball-size)] m-[var(--margin)] rounded-full border-solid bg-hsp-500 animate-grid;
}

.loading-overlay :global(.loader-grid div:nth-child(1)) {
  @apply [animation-delay:0ms];
}

.loading-overlay :global(.loader-grid div:nth-child(2)) {
  @apply [animation-delay:-400ms];
}

.loading-overlay :global(.loader-grid div:nth-child(3)) {
  @apply [animation-delay:-800ms];
}

.loading-overlay :global(.loader-grid div:nth-child(4)) {
  @apply [animation-delay:-400ms];
}

.loading-overlay :global(.loader-grid div:nth-child(5)) {
  @apply [animation-delay:-800ms];
}

.loading-overlay :global(.loader-grid div:nth-child(6)) {
  @apply [animation-delay:-1200ms];
}

.loading-overlay :global(.loader-grid div:nth-child(7)) {
  @apply [animation-delay:-800ms];
}

.loading-overlay :global(.loader-grid div:nth-child(8)) {
  @apply [animation-delay:-1200ms];
}

.loading-overlay :global(.loader-grid div:nth-child(9)) {
  @apply [animation-delay:-1600ms];
}

/**********************************************************************************************************************
 * Ring Loader
 **********************************************************************************************************************/
.loading-overlay :global(.loader-ring) {
  --multiplier: 1;
  --size: calc(var(--enterprise-ui-loader-size) * var(--multiplier));
  --border: calc((var(--size) / 18.75) * var(--multiplier));
}

.loading-overlay :global(.loader-ring div) {
  @apply absolute block h-[var(--size)] w-[var(--size)] rounded-full border-[calc(var(--border))] border-solid border-transparent border-t-hsp-500 animate-ring;
}

.loading-overlay :global(.loader-ring div:nth-child(1)) {
  @apply [animation-delay:450ms];
}

.loading-overlay :global(.loader-ring div:nth-child(2)) {
  @apply [animation-delay:300ms];
}

.loading-overlay :global(.loader-ring div:nth-child(3)) {
  @apply [animation-delay:150ms];
}
